import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState} from "react";
import {SelectOptionType} from "Model/Select/SelectOption";
import {getFamilyTypes} from "../../Api/Query/TutorQuery";

interface Props {
    onChange: (newValue: SelectOptionType|null) => void,
    onLoad?: (options: any[]) => void,
    value?: any,
    classes?: string,
    filters?: {[key:string]:string|number}
}

export const FamilyTypeSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])

    const queryQuery = useQuery({
        enabled: false,
        queryKey: ['getFamilyTypes'],
        queryFn: () => getFamilyTypes({size:0, sort:'position'}),
        onSuccess: (response: any) => {
            const items : object[] = []
            response.data._result.items.map((item:any) => {
                items.push({
                    label: item.name,
                    value: item.id
                })
            })
            setOptions(items)

            if(props.onLoad){
                props.onLoad(response.data._result.items)
            }
        }
    })

    useEffect(() => {
        queryQuery.refetch()
    }, [])

    return (
        <Select
            // isLoading={isLoading}
            value={props.value ?? null}
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={props.onChange}
            className={props.classes ?? ''}
        />
    )
}
